"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

require("./PulseAnnouncementMessage.scss");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PulseUtil = _interopRequireDefault(require("../../util/PulseUtil"));

var _Accordion = require("@react/react-spectrum/Accordion");

var _IconMapper = _interopRequireDefault(require("../../service/IconMapper.js"));

var _PulseApiHelper = _interopRequireDefault(require("../../service/PulseApiHelper"));

var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));

var _Tooltip = _interopRequireDefault(require("@react/react-spectrum/Tooltip"));

var _adobeIntlReact = _interopRequireWildcard(require("@adobe/adobe-intl-react"));

var Constants = _interopRequireWildcard(require("../../constants/Constants"));

var localizationStrings = _interopRequireWildcard(require("./__localization__/PulseAnnouncementMessage"));

var _metrics = _interopRequireDefault(require("@exc/runtime/metrics"));

/************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************/

/* eslint-disable @adobe/adobe-js/jsx-a11y/no-static-element-interactions */

/* eslint-disable @adobe/adobe-js/jsx-a11y/click-events-have-key-events */

/**
 * The base component that displays the announcement.
 */
var PulseAnnouncementMessage =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(PulseAnnouncementMessage, _Component);

  function PulseAnnouncementMessage(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PulseAnnouncementMessage);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PulseAnnouncementMessage).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "redirectToStatusSite", function (pulseMessageObject) {
      _this.metrics.event("flyout.announcement.click");

      window.open(_this.getHrefForMessage(pulseMessageObject), '_blank');
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderTimeAgo", function (timeInEpocSeconds, isShortHand) {
      return _react.default.createElement(_OverlayTrigger.default, {
        trigger: "hover",
        placement: "left",
        delayShow: Constants.TOOLTIP_DELAY_ON_TIME_AGO
      }, _react.default.createElement("div", {
        className: "pulse-announcement-message-time-ago"
      }, _PulseUtil.default.formatTimeAgo(timeInEpocSeconds * 1000, isShortHand)), _react.default.createElement(_Tooltip.default, null, _PulseUtil.default.formatDate(timeInEpocSeconds * 1000)));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderRelatedAccordion", function (pulseMessageObject) {
      var relatedannouncementslist = [];
      pulseMessageObject.related.forEach(function (announcement, key) {
        relatedannouncementslist.push(_react.default.createElement("div", {
          className: "pulse-announcement-message-related-item",
          key: key,
          onClick: function onClick() {
            return _this.redirectToStatusSite(pulseMessageObject);
          }
        }, _this.renderTimeAgo(announcement.createtimestamp, true), _this.renderMessageTextContent(announcement.message), _this.renderImpactedServices(pulseMessageObject)));
      });
      return relatedannouncementslist;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderImpactedServices", function (pulseMessageObject) {
      var impactedservicelist = [];
      pulseMessageObject.impactedservices.forEach(function (service, key) {
        impactedservicelist.push(_react.default.createElement("span", {
          className: "pulse-announcement-message-impacted-service",
          key: key
        }, "".concat(service).concat(pulseMessageObject.impactedservices.length - 1 == key ? '' : ',', " ")));
      });

      if (impactedservicelist.length > 0) {
        return _react.default.createElement("div", {
          className: "pulse-announcement-message-impacted-servics-list"
        }, _react.default.createElement(_adobeIntlReact.FormattedMessage, {
          messageId: "CapabilitiesAffected",
          defaultMessage: "Capabilities Affected: ",
          description: "CapabilitiesAffected"
        }), impactedservicelist);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderMessageTextContent", function (text) {
      return _react.default.createElement("div", {
        className: "pulse-announcement-message-text-content"
      }, text);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderHeader", function (pulseMessageObject) {
      var title = "".concat(pulseMessageObject.serviceName.replace('Adobe', ''), " - ");
      var subtitle = "".concat(pulseMessageObject.eventType, " - ");
      return _react.default.createElement("div", {
        className: "pulse-announcement-message-row1"
      }, _react.default.createElement("div", {
        className: "pulse-announcement-message-product-name"
      }, _react.default.createElement("span", null, title), _react.default.createElement("span", {
        className: "pulse-announcement-message-eventtype"
      }, subtitle, pulseMessageObject.announcementid)), _this.renderTimeAgo(pulseMessageObject.createTimeStamp, true));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderBody", function (pulseMessageObject) {
      return _react.default.createElement("div", {
        className: "pulse-announcement-message-row2"
      }, _react.default.createElement("div", {
        className: "pulse-announcement-message-row2-col1"
      }, _react.default.createElement(_OverlayTrigger.default, {
        trigger: "hover",
        placement: "top",
        offset: 10,
        delayShow: Constants.TOOLTIP_DELAY_ON_AVATAR
      }, _react.default.createElement("div", null, _react.default.createElement(_IconMapper.default, {
        product: pulseMessageObject.serviceName
      })), _react.default.createElement(_Tooltip.default, {
        className: "avatar-tooltip-label"
      }, pulseMessageObject.serviceName))), _react.default.createElement("div", {
        className: "pulse-announcement-message-row2-col2"
      }, _this.renderMessageTextContent(pulseMessageObject.messageContent), _this.renderImpactedServices(pulseMessageObject)));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderRelatedAnnouncementTile", function (pulseMessageObject) {
      var relatedCount = pulseMessageObject.related.length;
      return _react.default.createElement(_Accordion.AccordionItem, {
        header: _react.default.createElement(_adobeIntlReact.FormattedMessage, {
          messageId: "ShowRelated",
          defaultMessage: "Show {relatedCount} Related",
          values: {
            relatedCount: relatedCount
          },
          description: "Show Related"
        }),
        className: "pulse-announcement-related-accordion",
        onClick: function onClick(event) {
          event.stopPropagation();
        }
      }, _this.renderRelatedAccordion(pulseMessageObject));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderFooter", function (pulseMessageObject) {
      return _react.default.createElement("div", {
        className: "pulse-announcement-message-row3"
      }, _react.default.createElement(_Accordion.Accordion, {
        className: "pulse-announcement-accordian"
      }, pulseMessageObject.related.length > 0 ? _this.renderRelatedAnnouncementTile(pulseMessageObject) : null));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getHrefForMessage", function (pulseMessageObject) {
      var pulseApiHelper = new _PulseApiHelper.default();
      var url = new URL("".concat(pulseApiHelper.getAdobeStatusHostUrl(), "/products/").concat(pulseMessageObject.productid, "?id=").concat(pulseMessageObject.announcementid));
      return url;
    });
    _this.metrics = _metrics.default.create("exc.pulse.components.message.PulseAnnouncementMessage");
    return _this;
  }

  (0, _createClass2.default)(PulseAnnouncementMessage, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          pulseMessageObject = _this$props.pulseMessageObject,
          locale = _this$props.locale;
      return _react.default.createElement(_adobeIntlReact.default, {
        locale: locale,
        localeData: localizationStrings
      }, _react.default.createElement("div", {
        className: "pulse-announcement-message-root",
        onClick: function onClick() {
          return _this2.redirectToStatusSite(pulseMessageObject);
        }
      }, this.renderHeader(pulseMessageObject), this.renderBody(pulseMessageObject), this.renderFooter(pulseMessageObject)));
    }
  }]);
  return PulseAnnouncementMessage;
}(_react.Component);

exports.default = PulseAnnouncementMessage;
(0, _defineProperty2.default)(PulseAnnouncementMessage, "propTypes", {
  pulseMessageObject: _propTypes.default.object.isRequired,
  onMessageCloseClicked: _propTypes.default.func
});